export const FEATURES_PAGE_FEATURES = [
  {
    id: 'advanced-contact-manager',
    title: 'Advanced Contact Manager',
    description:
      'Store all your contacts in one secure location with customizable fields and powerful search capabilities designed for the modern contact manager experience.',
  },
  {
    id: 'ai-mcp-server',
    title: 'AI Features (MCP Server)',
    description:
      'Use AI tools with your people database via a local MCP (Model Context Protocol) server—search contacts, list groups, and get smart summaries while keeping control.',
    link: {
      href: '/features-ai',
      text: 'Learn more about AI features →',
    },
  },
  {
    id: 'merge-duplicates',
    title: 'Merge Duplicate Contacts',
    description:
      'Consolidate duplicate entries into a single clean record to keep your address book accurate and uncluttered.',
  },
  {
    id: 'smart-organization',
    title: 'Smart Organization',
    description:
      'Organize contacts by groups, tags, and relationships to quickly find the right people when you need them.',
    link: {
      href: '/features-groups',
      text: 'Learn more about Groups →',
    },
  },
  {
    id: 'calendar-reminders',
    title: 'Calendar Reminders',
    description:
      'See upcoming birthdays and important anniversaries so you can stay connected with the people who matter.',
  },
  {
    id: 'privacy-controls',
    title: 'Privacy Controls',
    description:
      'Advanced security features to keep your people data safe with customizable privacy settings.',
  },
  {
    id: 'digital-address-book',
    title: 'Digital Address Book',
    description:
      'A complete address book solution that connects with your existing tools and services for seamless import/export capabilities.',
  },
  {
    id: 'complete-data-ownership',
    title: 'Complete Data Ownership',
    description:
      'Take full ownership of your data and relationships. Unlike social platforms where your connections become their business asset, MyPeopleDatabase ensures you exclusively own and control your network and all associated information.',
  },
  {
    id: 'intuitive-interface',
    title: 'Intuitive Interface',
    description:
      'Easy-to-use dashboard and navigation designed for efficiency and minimal learning curve.',
  },
];
